import { useQuery } from '@hooks/reactQuery';

import { getConfigurationComparisonNodes } from '@api/configurationComparison';

import { fieldsOptionsFormatted } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { EVendorsValues, TVendorsValues } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CC_NODES } from '@constants/queryKeys';

export const useQueryConfigurationComparisonNodes = (vendor?: TVendorsValues): {
	nodesOptions: TSelectOption<string>[];
	isLoadingNodesOptions: boolean;
} => {
	const {
		data: nodesOptions,
		isFetching: isFetchingNodesOptions,
		isLoading: isLoadingNodesOptions,
	} = useQuery<Array<string>, TSelectOption<string>[]>({
		queryKey: [CC_NODES, vendor],
		queryFn: () => getConfigurationComparisonNodes(vendor!),
		select: (options: Array<string>) => {
			return fieldsOptionsFormatted(options);
		},
		enabled: [!!vendor, vendor === EVendorsValues.mavenir],
		...refetchOptions,
	});

	return {
		nodesOptions: nodesOptions || [],
		isLoadingNodesOptions: isLoadingNodesOptions && isFetchingNodesOptions,
	};
};
